import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import RichTitle from '../components/assessment/RichTitle';
import './ResultsBox.scss';

const ResultsBox = (props) => {
  const hSize = (contents) => {
    const { size } = props;

    if (size === 'small') {
      return (
        <h3 className="ahd__title">
          <RichTitle title={contents} />
        </h3>
      );
    }
    return (
      <h2 className="ahd__title">
        <RichTitle title={contents} />
      </h2>
    );
  };
  const { title, optionalTitle, className, children, studentDashboard } = props;
  const theTitle = optionalTitle || title;

  return (
    <div
      className={cn(`ResultsBox ${className}`, {
        'ResultsBox--dashboard': studentDashboard,
      })}
    >
      {theTitle ? (
        <div className="ResultsBox__title">
          {hSize(theTitle)}
          {optionalTitle ? (
            <RichTitle
              content={
                title === 'null' || title == null ? '<em>no title</em>' : title
              }
            />
          ) : null}
        </div>
      ) : null}
      <div className="ResultsBox__content">{children}</div>
    </div>
  );
};

ResultsBox.propTypes = {
  size: PropTypes.oneOf(['small', 'large']),
  className: PropTypes.string,
};

ResultsBox.defaultProps = {
  className: '',
};

export default ResultsBox;
